/**
 * Bumpers PDP: sold-out size state for the main add-to-cart (standalone, 31.10.2026, Gal approved).
 * When the picked size (input[name="v46-size"]) is sold out in this colour, the main ATC shows
 * «אזל מהמלאי» and is disabled, and the sticky bar button is disabled too. Picking an in-stock size
 * restores both exactly as they were. Other colours in the same size + «עדכנו אותי כשחוזרת» come
 * from snippets/bumpers-waitlist.liquid (unchanged). Ported from the draft buybox file, nothing else.
 */
(function () {
  var LABEL = 'אזל מהמלאי';

  function mainBtn() {
    return document.querySelector('[id^="ProductSubmitButton-"]');
  }
  function stickyBtn() {
    var host = document.querySelector('[class*="ai-sticky-atc-"]:not([class*="__"])');
    return host ? host.querySelector('[data-add], button') : null;
  }
  function labelEl(btn) {
    return btn.querySelector('span') || btn;
  }

  function sync() {
    var btn = mainBtn();
    if (!btn) return;
    var checked = document.querySelector('input[name="v46-size"]:checked');
    var soldOut = !!checked && (checked.getAttribute('data-av') === 'false' || checked.disabled);
    var sb = stickyBtn();

    if (soldOut) {
      if (!btn.classList.contains('bmp-atc--sold-out')) {
        var l = labelEl(btn);
        btn.setAttribute('data-bmp-so-label', l.textContent);
        btn.setAttribute('data-bmp-so-disabled', btn.disabled ? '1' : '0');
        l.textContent = LABEL;
        btn.classList.add('bmp-atc--sold-out');
      }
      btn.disabled = true;
      if (sb && !sb.hasAttribute('data-bmp-so-disabled')) {
        sb.setAttribute('data-bmp-so-disabled', sb.disabled ? '1' : '0');
        sb.disabled = true;
        sb.setAttribute('aria-disabled', 'true');
      }
    } else {
      if (btn.classList.contains('bmp-atc--sold-out')) {
        labelEl(btn).textContent = btn.getAttribute('data-bmp-so-label') || labelEl(btn).textContent;
        btn.disabled = btn.getAttribute('data-bmp-so-disabled') === '1';
        btn.classList.remove('bmp-atc--sold-out');
        btn.removeAttribute('data-bmp-so-label');
        btn.removeAttribute('data-bmp-so-disabled');
      }
      if (sb && sb.hasAttribute('data-bmp-so-disabled')) {
        /* Same rule the sticky block uses itself: enabled once its size select has a value. */
        var host = sb.closest('[class*="ai-sticky-atc-"]:not([class*="__"])');
        var sel = host && host.querySelector('[data-variant], select');
        sb.disabled = sel ? !sel.value : sb.getAttribute('data-bmp-so-disabled') === '1';
        sb.removeAttribute('data-bmp-so-disabled');
        sb.removeAttribute('aria-disabled');
      }
    }
  }

  function init() {
    if (!document.querySelector('input[name="v46-size"]')) return;
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'v46-size') setTimeout(sync, 0);
    });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
